/**
 * DOC-AUDIT-1 S2 — the document beacon, SENDER half. Installs itself on import (side-effect import in
 * `main.tsx`), so every `recordDocumentBeacon(...)` call reaches `POST /document-access/beacon`.
 * Fire-and-forget: the request is never awaited and its failure is swallowed.
 */
import api from '../services/api';
import { setDocumentBeaconSender } from './document-beacon-core';

setDocumentBeaconSender((beacon) => {
  void api.post('/document-access/beacon', beacon).catch(() => undefined);
});
